import { render, staticRenderFns } from "./WaterDamageQualification.vue?vue&type=template&id=6c0c00c6"
import script from "./WaterDamageQualification.vue?vue&type=script&lang=ts"
export * from "./WaterDamageQualification.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports